import { useForm } from 'react-hook-form';
import { useTranslation } from '@/i18n/client';
import { Button, TextField, FieldHint } from 'ui';
import { emailPattern, isEmptyObject } from 'utils';
import { useState } from 'react';
import { forgotPassword } from '@/modules/account/api';

import { RemindPasswordFormModel, RemindPasswordFormProps } from './types';
import styles from './RemindPasswordForm.module.scss';

export const RemindPasswordForm = ({ setFormSent, backToLoginPress }: RemindPasswordFormProps) => {
	const { t } = useTranslation(['header', 'common', 'checkout']);
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm<RemindPasswordFormModel>();
	const [isLoading, setIsLoading] = useState(false);

	const onSubmit = async (data: RemindPasswordFormModel) => {
		setIsLoading(true);
		await forgotPassword(data.email);

		setFormSent(data.email);
	};

	return (
		<div className={styles.remindPasswordForm__formWrapper}>
			<h2 className={styles.remindPasswordForm__title}>{t('authModal.remindPasswordTitle')}</h2>
			<form onSubmit={handleSubmit(onSubmit)}>
				<p className={styles.remindPasswordForm__caption}>{t('authModal.remindPasswordCaption')}</p>
				<TextField
					label={t('common:common.emailAddress')}
					{...register('email', {
						required: t('checkout:details.fieldRequired') || '',
						pattern: {
							value: emailPattern,
							message: t('checkout:details.invalidEmail') || '',
						},
					})}
					hasError={!!errors.email}
				/>
				{errors.email ? <FieldHint isError>{errors.email?.message}</FieldHint> : null}
				<Button
					type="submit"
					buttonName="remindPasswordButton"
					variant="blue"
					fullWidth
					isLoading={isLoading}
					isDisabled={isLoading || !isEmptyObject(errors)}
				>
					{t('common:common.send')}
				</Button>
			</form>
			<Button variant="iconButton" buttonName="backToLoginButton" onPress={backToLoginPress}>
				{t('authModal.backToLogin')}
			</Button>
		</div>
	);
};
